import { createRef, useEffect, useContext } from "react";
import CrudModuleFactoryModal from "@beeldit/core/components/CrudModuleFactoryModal";
import UserForm from "../components/UserForm";
import UserTable from "../components/UserTable";
import getConfig from "../configs/tableConfig";
import JSONSchemaForm from "@rjsf/core";

import useFilters from "@beeldit/core/helpers/useFilters";
import BeelditTableFilters from "@beeldit/core/components/BeelditTableFilters";
import AddQueryParamsToURL from "@beeldit/core/helpers/AddQueryParamsToURL";
import CrudModuleFactoryConfirmationModal from "@beeldit/core/components/CrudModuleFactoryConfirmationModal";
import getFiltersConfig from "../configs/filterConfig";
import { Card } from "react-bootstrap";
import BeelditTableHeaderActions from "@beeldit/core/components/BeelditTableHeaderActions";
import { AuthContext } from "../../auth/AuthContext";
import useListAction from "../actions/list/useListAction";
import useCreateAction from "../actions/create/useCreateAction";
import useEditAction from "../actions/edit/useEditAction";
import useRemoveAction from "../actions/remove/useRemoveAction";
import { t } from "i18next";

function UserPage(props: any) {
  const { filters = {} } = props;
  const { user } = useContext(AuthContext);

  // Establecer valor por defecto para rol si no está definido
  if (!filters.role) {
    filters.role = "admin";
  }

  const {
    indexFunction,
    actionTemplate: listActionTemplate,
    setTableConfig,
  } = useListAction(user, filters);

  const { initializeFunction, actionTemplate: createActionTemplate } =
    useCreateAction(indexFunction);

  const { getFunction, actionTemplate: editActionTemplate } =
    useEditAction(indexFunction);

  const { prepareRemoveFunction, actionTemplate: removeActionTemplate } =
    useRemoveAction(indexFunction);

  /**
   * Table configuration definition
   */
  const tableConfig = getConfig({
    initializeFunction, // We pass the function to initialize a new element (used in the create button)
    indexFunction, // We pass the function to index the table
    getFunction, // We pass the function to get an element (used in the edit button)
    prepareRemoveFunction,
    /**newActionsTableConfig**/
  });
  setTableConfig(tableConfig);
  return (
    <Card>
      <Card.Header className="d-flex align-items-center justify-content-between ps-3 bg-white">
        <span>{t("users")}</span>
        <div>
          <BeelditTableHeaderActions
            actions={tableConfig.actions}
          ></BeelditTableHeaderActions>
        </div>
      </Card.Header>

      <Card.Body>
        {listActionTemplate}
        {createActionTemplate}
        {editActionTemplate}
        {removeActionTemplate}
        {/* newTemplateActions */}
      </Card.Body>
    </Card>
  );
}

export default UserPage;
